var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 10.8H3.8m5.6 0H8.35M1 6.6h14M1 8c0-2.64 0-3.96.82-4.78.82-.82 2.14-.82 4.78-.82h2.8c2.64 0 3.96 0 4.78.82C15 4.04 15 5.36 15 8s0 3.96-.82 4.78c-.82.82-2.14.82-4.78.82H6.6c-2.64 0-3.96 0-4.78-.82C1 11.96 1 10.64 1 8z",
    stroke: "currentColor",
    strokeWidth: 1.077,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.1d3d953cdb839142a6d7c2a2e8c37d80.svg";
export { ForwardRef as ReactComponent };